import React, { useMemo, useState } from "react";
import { MdClose } from "react-icons/md";
import "./TagMsnsPopup.scss";

interface TagMsnsPopupProps {
  msns: string[];
  tagName?: string;
  onClose: () => void;
}

const TagMsnsPopup: React.FC<TagMsnsPopupProps> = ({ msns, tagName, onClose }) => {
  const [search, setSearch] = useState("");

  // Tags can carry thousands of MSNs, so finding one by eye is not realistic.
  const visibleMsns = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return msns;
    return msns.filter((msn: string) => String(msn).toLowerCase().includes(query));
  }, [msns, search]);

  return (
    <div className="popup-container">
      <div className="overlay">
        <div className="popup-content popup-card tag-msns-popup">
          <div className="popup-head flex items-start justify-between">
            <div>
              <h2>Tagged MSNs ({msns.length})</h2>
              <p>{tagName ? `Products currently carrying the ${tagName} tag` : "Products currently carrying this tag"}</p>
            </div>
            <button onClick={onClose} title="Close" className="popup-close flex items-center justify-center">
              <MdClose size={18} />
            </button>
          </div>

          <div className="popup-body">
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search MSN"
              className="w-full h-9 rounded border border-[#EAEAEA] text-[#555] outline-none focus:border-blue-400 px-2.5 text-sm font-light"
            />
            {search && (
              <p className="text-[11px] text-[#858585] font-light mt-2">
                {visibleMsns.length} of {msns.length} shown
              </p>
            )}
            <div className="flex flex-wrap mt-4">
              {visibleMsns.length === 0 ? (
                <p className="text-xs text-gray-500 py-6 w-full text-center">No MSN matches your search.</p>
              ) : (
                visibleMsns.map((item: any, index: number) => (
                  <span
                    className="bg-[#CEE1FD] text-xs px-3 py-2 rounded-3xl text-center mr-2.5 mb-2.5 text-[#3A3A3A]"
                    key={index}
                  >
                    {item}
                  </span>
                ))
              )}
            </div>
          </div>

          <div className="popup-foot bottom-btn-cta flex justify-end items-center">
            <button
              onClick={onClose}
              className="bg-blue-500 text-white font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 py-2 px-6"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagMsnsPopup;
